import { IOpeningTime } from '../../../components/VenueOpeningTimeEditModal/types';
import { TDay } from 'src/types/venue.types';

type TDirtyOpeningTime = Partial<Record<keyof IOpeningTime, boolean>>;
type TDirtyOpeningTimes = Partial<Record<TDay, TDirtyOpeningTime[]>>;

const filterChangedDays = (dirtyDayOpeningTimes: TDirtyOpeningTimes) =>
  Object.entries(dirtyDayOpeningTimes || {})
    .filter(([, value]: [string, TDirtyOpeningTime[]]) =>
      value.some((obj: TDirtyOpeningTime) => Object.values(obj).some(Boolean)),
    )
    .map(([key]: [string, TDirtyOpeningTime[]]) => key);

export default filterChangedDays;
